@if (depositRedirectService?.popupBlocked()) {
    <show-message [type]="messageType.INFO">
        <div info>
            <p>{{ 'PARTY.CASHIER.web.deposit.popupblock.message' | translate }}</p>
        </div>
    </show-message>
    <button class="btn btn-primary w-100 mb-2" (click)="redirectToThirdParty()">
        {{ 'PARTY.CASHIER.web.continue' | translate }}
    </button>
} @else {
    <show-message [type]="messageType.INFO">
        <div info>
            <p>{{ 'PARTY.CASHIER.web.deposit.redirected.message' | translate }}</p>
        </div>
    </show-message>
}
